import comp from "./CustomSelectionList";
export default comp;
